export * from './providers';
export * from './MxConfiguration';

/**
 * @deprecated Use createProvider instead.
 */
export const createConfig = (config: unknown) => ({
    get: () => undefined,
    getClient: () => undefined,
    setContext: () => {},
    addToContext: () => undefined,
    getContext: () => undefined,
});
